import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

/* LIBRARIES */
import * as React from 'react';
import classNames from 'classnames';
import { isEmpty } from 'ramda';
import { getDisplayName } from '../../utils/getDisplayName';
/* MODULES */

import { getCustomClasses, getStylesClasses, getInlineStyles } from './helpers';
/* STYLES */

import * as stylesModule from './styles.css';
/* TYPES */

export var createIcon = function createIcon(IconComponent, config) {
  var _class, _temp;

  var displayName = "Icon(".concat(getDisplayName(IconComponent), ")");
  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Icon, _React$Component);

    function Icon() {
      _classCallCheck(this, Icon);

      return _possibleConstructorReturn(this, _getPrototypeOf(Icon).apply(this, arguments));
    }

    _createClass(Icon, [{
      key: "render",
      value: function render() {
        var _classNames;

        var props = this.props;
        var _props$dataMark = props.dataMark,
            dataMark = _props$dataMark === void 0 ? displayName : _props$dataMark,
            __classNames = props.__classNames,
            __attributes = props.__attributes,
            custom = props.custom;
        return React.createElement("div", _extends({
          "data-mark": dataMark,
          className: classNames(stylesModule['container'], config && config.containerClass, (_classNames = {}, _defineProperty(_classNames, getCustomClasses(custom), !isEmpty(custom)), _defineProperty(_classNames, getStylesClasses(props, config), !isEmpty(props)), _classNames), __classNames),
          style: getInlineStyles(props)
        }, __attributes), React.createElement("div", {
          className: stylesModule['icon']
        }, React.createElement(IconComponent, null)));
      }
    }]);

    return Icon;
  }(React.Component), _defineProperty(_class, "displayName", displayName), _defineProperty(_class, "SVG", IconComponent), _temp;
};